import { useBehavior } from '../extensions/hooks/useBehavior';
import BehaviorRenderer from '../extensions/components/BehaviorRenderer';
import { DataWell } from '../extensions/constants/BehaviorTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataWellComponent = () => {
  const DataWellBehavior = useBehavior(DataWell);
  return /*#__PURE__*/_jsx(BehaviorRenderer, {
    Component: DataWellBehavior
  });
};